import { Box, Flex, Image, Text } from "@mantine/core";
import { formatNgayThangNam } from "../../../../common/FormatDate/FormatDate";
import { formatCurrency } from "../../../../common/formatPrice/PriceFunction";
import {
  dataOrderDetailTable,
  OrderHeader,
} from "../../../../model/SaleOrderModel";
import { PrintOrderModalType } from "./OptionPrintOrder";
type Props = {
  componentRef: any;
  valuePrintOrderModal: PrintOrderModalType;
  listAdd?: dataOrderDetailTable[];
  orderHeader?: OrderHeader;
};
const PrintOderhandover = ({
  componentRef,
  valuePrintOrderModal,
  listAdd,
  orderHeader,
}: Props) => {
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  console.log("LogValuePrintOrderModal", valuePrintOrderModal);
  console.log("LoglistAdd", listAdd);
  console.log("LogorderHeader", orderHeader);

  const tongThanhTien = (listAdd ?? [])
    .filter(
      (item) => valuePrintOrderModal?.inKemDichVu || item.lineTyle !== "DV",
    )
    .reduce((sum, item) => {
      const displayedPrice = Math.max(
        (item.priceFinal ?? 0) * (item.quality ?? 0),
        0,
      );
      return sum + displayedPrice;
    }, 0);

  const getCompanyName = (attribute8?: string) => {
    if (!attribute8) return "";
    return attribute8.split("||")[0].trim();
  };
  return (
    <div
      ref={componentRef}
      style={{
        height: "100%",
        margin: "0 auto",
        marginLeft: "40px",
        marginRight: "30px",
        fontFamily: `"Times New Roman", Times, serif`,
        position: "relative",
      }}
    >
      <Box
        style={{
          width: "100%",
          position: "relative",
          margin: "0 auto",
          marginRight: "20px",
          paddingRight: "20px",
        }}
      >
        {/* header */}
        <Box>
          <Box style={{ textAlign: "center" }}>
            <Text size="md">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM </Text>
            <Text size="md">Độc lập - Tự do - Hạnh phúc</Text>
            <Text
              fw={700}
              style={{
                fontSize: "23px",
                marginTop: "8px",
                marginBottom: "4px",
              }}
            >
              BIÊN BẢN BÀN GIAO VÀ NGHIỆM THU KỸ THUẬT
            </Text>
            {/* <Text size="md">  Số: {valuePrintOrderModal?.soHopDong}/BBBG/KG- KDOL.HACOM/2025</Text> */}
            <Text
              size="md"
              style={{
                marginBottom: "4px",
              }}
            >
              {" "}
              {valuePrintOrderModal?.soHopDong
                ? valuePrintOrderModal?.soHopDong
                : orderHeader?.orderNumber}
            </Text>
          </Box>
        </Box>
        {/* main */}
        <Box>
          <>
            <ul
              style={{
                margin: 0,
                padding: 0,
                listStyleType: "square",
                paddingLeft: "15px",
              }}
            >
              <li>
                Căn cứ vào hợp đồng/báo giá{" "}
                {valuePrintOrderModal?.ngayBaoGia
                  ? formatNgayThangNam(String(valuePrintOrderModal?.ngayBaoGia))
                  : ""}{" "}
                giữa <strong> {getCompanyName(orderHeader?.attribute8)}</strong>{" "}
                và{" "}
                <strong>
                  {" "}
                  {orderHeader &&
                  orderHeader.orgId &&
                  (orderHeader?.orgId === 222 || orderHeader?.orgId === 223)
                    ? "Công ty Cổ phần HACOM Dịch Vụ Tốt"
                    : "Công Ty Cổ Phần Đầu Tư Công Nghệ HACOM"}
                </strong>
                .
              </li>

              <li>Căn cứ vào vào tình hình hiện tại công việc hai bên.</li>
            </ul>
          </>

          <Box>
            <Text style={{ margin: "15px 0" }}>
              Hôm nay,{" "}
              {formatNgayThangNam(String(valuePrintOrderModal?.ngayBanGiao))},
              tại Hà Nội chúng tôi gồm:
            </Text>
          </Box>

          <Box>
            <Box>
              <Text fw={700} size="lg">
                BÊN MUA(BÊN A)
              </Text>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Công ty</Text>
                </div>
                <div>
                  <Text size="md">
                    :{" "}
                    <strong> {getCompanyName(orderHeader?.attribute8)}</strong>
                  </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px", minWidth: "100px" }}>
                  <Text size="md">Địa chỉ</Text>
                </div>
                <div>
                  <Text size="md">: {valuePrintOrderModal?.diachiBM}</Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Mã số thuế</Text>
                </div>
                <div>
                  <Text size="md">: {valuePrintOrderModal?.maSoThueBM}</Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Người đại diện</Text>
                </div>
                <div>
                  <Text size="md">: {valuePrintOrderModal?.daiDienBM}</Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Chức vụ</Text>
                </div>
                <div>
                  <Text size="md">: {valuePrintOrderModal?.chucVuBM}</Text>
                </div>
              </Flex>
            </Box>
            <Box>
              <Text fw={700} size="lg">
                BÊN BÁN(BÊN B)
              </Text>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Công ty</Text>
                </div>
                <div>
                  <Text size="md">
                    :{" "}
                    <strong>
                      {" "}
                      {orderHeader &&
                      orderHeader.orgId &&
                      (orderHeader?.orgId === 222 || orderHeader?.orgId === 223)
                        ? "CÔNG TY CỔ PHẦN HACOM DỊCH VỤ TỐT"
                        : "CÔNG TY CỔ PHẦN ĐẦU TƯ CÔNG NGHỆ HACOM"}
                    </strong>
                  </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px", minWidth: "100px" }}>
                  <Text size="md">Địa chỉ</Text>
                </div>
                <div>
                  <Text size="md">
                    :{" "}
                    {orderHeader &&
                    orderHeader.orgId &&
                    (orderHeader?.orgId === 222 || orderHeader?.orgId === 223)
                      ? "Số 65 Thái Hà, phường Đống Đa, Thành phố Hà Nội"
                      : "Số 129 + 131, phố Lê Thanh Nghị, Phường Bạch Mai, TP Hà Nội, Việt Nam."}
                  </Text>
                </div>
              </Flex>

              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Mã số thuế</Text>
                </div>
                <div>
                  <Text size="md">: 0101161194 </Text>
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"flex-start"}
                style={{ margin: "3px 0" }}
              >
                <div style={{ width: "100px" }}>
                  <Text size="md">Người đại diện</Text>
                </div>
                <div>
                  <Text size="md">: {valuePrintOrderModal?.daiDienBB}</Text>
                </div>
              </Flex>
              <>
                <Flex
                  direction={"row"}
                  align={"center"}
                  justify={"flex-start"}
                  style={{ margin: "3px 0" }}
                >
                  <div style={{ width: "100px" }}>
                    <Text size="md">Chức vụ</Text>
                  </div>
                  <div>
                    <Text size="md">: {valuePrintOrderModal?.chucVuBB}</Text>
                  </div>
                </Flex>
              </>
            </Box>
          </Box>

          <Box>
            <Text size="md" style={{ margin: "10px 0" }}>
              Hai bên cùng nhau tiến hành bàn giao hàng hoá với các nội dung
              sau:{" "}
            </Text>
            <Text size="lg" fw={700}>
              1. Danh mục hàng hóa và giá trị bàn giao:
            </Text>
            <ul
              style={{
                listStyleType: "none",
                margin: 0,
                padding: 0,
                paddingLeft: "15px",
              }}
            >
              <li>
                {/* table sản phẩm */}
                <div
                  // className={styles.ProductMain}
                  style={{
                    width: "100%",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      border: "1px solid black",
                      tableLayout: "auto",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          STT
                        </th>
                        <th
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          Danh mục thiết bị
                        </th>
                        {valuePrintOrderModal?.inSoLuong && (
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            Số lượng
                          </th>
                        )}
                        {valuePrintOrderModal?.inGiaTien && (
                          <>
                            <th
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Đơn giá ( VNĐ )
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Thành tiền ( VNĐ )
                            </th>
                          </>
                        )}

                        <th
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          Bảo hành
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {valuePrintOrderModal?.inGiaTien && (
                        <tr>
                          <td
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              paddingLeft: "3px",
                            }}
                            colSpan={4}
                          >
                            <strong>Tổng tiền (đã bao gồm VAT)</strong>
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              paddingLeft: "3px",
                            }}
                            colSpan={2}
                          >
                            <strong>
                              {tongThanhTien
                                ? formatCurrency(tongThanhTien)
                                : formatCurrency(0)}
                            </strong>
                          </td>
                        </tr>
                      )}
                      {listAdd && listAdd.length > 0 && (
                        <>
                          {listAdd
                            .filter(
                              (item: dataOrderDetailTable) =>
                                valuePrintOrderModal?.inKemDichVu ||
                                item.lineTyle !== "DV",
                            )
                            .map(
                              (item: dataOrderDetailTable, index: number) => {
                                return (
                                  <>
                                    <tr key={index}>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          textAlign: "center",
                                          paddingLeft: "3px",
                                        }}
                                      >
                                        {index + 1}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          textAlign: "center",
                                          paddingLeft: "3px",
                                        }}
                                      >
                                        {" "}
                                        <strong>{item.itemName}</strong>
                                      </td>
                                      {valuePrintOrderModal?.inSoLuong && (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            paddingLeft: "3px",
                                          }}
                                        >
                                          {item.quality}
                                        </td>
                                      )}
                                      {valuePrintOrderModal?.inGiaTien && (
                                        <>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              textAlign: "center",
                                            }}
                                          >
                                            {formatCurrency(
                                              item.priceOnPriceList,
                                            )}
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              textAlign: "center",
                                            }}
                                          >
                                            {(() => {
                                              const displayedPrice = Math.max(
                                                (item.priceFinal ?? 0) *
                                                  (item.quality ?? 0),
                                                0,
                                              );
                                              return formatCurrency(
                                                displayedPrice,
                                              );
                                            })()}
                                          </td>
                                        </>
                                      )}
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          textAlign: "center",
                                        }}
                                      >
                                        {item.attribute20
                                          ? item.attribute20
                                          : ""}
                                      </td>
                                    </tr>
                                  </>
                                );
                              },
                            )}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </li>
            </ul>
            <Text size="lg" fw={700} style={{ marginTop: "10px" }}>
              2. Các công việc đã thực hiện theo hợp đồng:
            </Text>
            <ul
              style={{
                listStyleType: "square",
                margin: 0,
                padding: 0,
                paddingLeft: "15px",
              }}
            >
              <li>
                Bên B đã hoàn thành việc cung cấp, lắp đặt và bàn giao đầy đủ
                hàng hóa với đúng số lượng, chủng loại theo nội dung báo giá.
              </li>
              <li>
                Tất cả các thiết bị Bên B bàn giao hoạt động bình thường với sự
                kiểm tra của Bên A; chất lượng hàng hóa và dịch vụ đã đảm bảo
                yêu cầu.
              </li>
              <li>
                {" "}
                Bên B có trách nhiệm tiếp tục thực hiện các điều khoản liên quan
                đến bảo hành đã quy định.
              </li>

              <li>
                Bên A có trách nhiệm tiếp tục thực hiện các nghĩa vụ thanh toán
                cho Bên B theo các điều khoản liên quan đến thanh toán đã quy
                định. (nếu có).
              </li>
              <li>
                Biên bản này được lập thành 02 bản có giá trị pháp lý như nhau,
                mỗi bên giữ 01 bản làm căn cứ để thực hiện.
              </li>
            </ul>
          </Box>

          <Box style={{ pageBreakInside: "avoid" }}>
            <Flex
              direction={"row"}
              align={"center"}
              justify={"space-evenly"}
              style={{ marginTop: "20px" }}
            >
              <Text fw={700} size="lg">
                ĐẠI DIỆN BÊN A
              </Text>
              <Text fw={700} size="lg">
                ĐẠI DIỆN BÊN B
              </Text>
            </Flex>
          </Box>
        </Box>
      </Box>
      <Box
        style={{
          position: "absolute",
          width: "100%",
          zIndex: -1,
          opacity: 0.1,
          top: "40%",
        }}
      >
        <Image
          radius="md"
          src="https://hanoicomputercdn.com/media/lib/17-10-2024/logo-hacom-since-2001_new.png"
          style={{
            width: "90%",
            margin: "0 auto",
          }}
        />
      </Box>
    </div>
  );
};

export default PrintOderhandover;
